import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/Input";
import { ModalProps } from "@/lib/type";
import { useAppSelector } from "@/redux/features/hooks";
import { useAddFranchiseOwnerMutation } from "@/redux/services/restaurant/restaurant.api";
import { AddFranchiseOwnerPayload } from "@/redux/services/restaurant/restaurant.type";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import { cleanerError } from "@/lib/utils";

const schema = yup.object().shape({
  phone: yup.string().required().label("Téléphone"),
  fullName: yup.string().label("Nom complet"),
});

const AddFranchiseOwnerModal: React.FC<ModalProps<void>> = ({
  isOpen,
  onClose,
}) => {
  const { currentFranchise } = useAppSelector((s) => s.user);
  const [addOwner, { isLoading }] = useAddFranchiseOwnerMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm<AddFranchiseOwnerPayload>({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (errors) {
      cleanerError(errors, clearErrors);
    }
  }, [errors, clearErrors]);

  const onSubmit = async (data: AddFranchiseOwnerPayload) => {
    const res = await addOwner({
      franchiseId: currentFranchise?.id as string,
      data,
    });

    if ("data" in res) {
      toast.success("Propriétaire ajouté avec succès");
      onClose();
    } else if ("error" in res) {
      toast.error("Une erreur est survenue");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogHeader className="mb-8">
            <DialogTitle>Ajouter un propriétaire</DialogTitle>

            <div>
              <Input
                label="Téléphone"
                type="tel"
                id="phone"
                placeholder="Téléphone"
                required
                {...register("phone")}
                error={errors?.phone}
              />
            </div>
            <div>
              <Input
                label="Nom complet"
                type="text"
                id="fullName"
                placeholder="Nom complet (optionnel)"
                {...register("fullName")}
                error={errors?.fullName}
              />
            </div>
          </DialogHeader>

          <DialogFooter>
            <Button
              type="submit"
              isLoading={isLoading}
            >
              Ajouter
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddFranchiseOwnerModal;
